import { render, staticRenderFns } from "./productNotice.vue?vue&type=template&id=ed6933e8&scoped=true"
import script from "./productNotice.vue?vue&type=script&lang=ts"
export * from "./productNotice.vue?vue&type=script&lang=ts"
import style0 from "./productNotice.vue?vue&type=style&index=0&id=ed6933e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6933e8",
  null
  
)

export default component.exports